import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/rootReducer";
import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react/polaris";
import React from "react";
import { removeNotification } from "./notificationConnector";

export const Notification = () => {
  const dispatch = useDispatch();
  const { notificationItems } = useSelector(
    (state: RootState) => state.notification
  );
  const flashBarItems: FlashbarProps.MessageDefinition[] = Object.entries(
    notificationItems
  ).map(([key, value]) => {
    return {
      ...value,
      onDismiss: () => dispatch(removeNotification(parseInt(key, 10))),
    };
  });
  return <Flashbar items={flashBarItems} />;
};
